:host {
  @apply block;
}

::slotted(img) {
  @apply w-full h-full object-cover;
}

::slotted(picture) {
  @apply flex w-full h-auto overflow-hidden;
}

::slotted(img),
::slotted(picture) {
  @apply rounded-full;
}
